import {
    createOptionPickerComponent,
    OptionPicker,
} from '@vfde-brix/option-picker';

/**
 * Mount the option picker
 * @param container
 * @param uuid
 * @param optType
 * @param items
 * @param onChange
 */
const mountOptionPicker = (container, uuid, optType, items, onChange: (Event: Event) => void): OptionPicker => {
    const containerEle = document.getElementById(container) as HTMLElement;

    return createOptionPickerComponent(containerEle, {
        items,
        optType,
        uuid,
        business: {
            onChange,
        },
    });
};

export default mountOptionPicker;
